import { Dispatch } from 'redux';
import { getTopAirports, getTopAircraft, getMonthlySummary, getRoutes, getOilConsumption } from '../../services/apiNew';
import { FlightRoute, OperationsActionTypes } from '.';

interface TopAirportsPayload {
  payload: {
    from: string;
    to: string;
    aircraft_id: string[];
  };
}

export const fetchTopAirports =
  ({ payload }: TopAirportsPayload) =>
  async (dispatch: Dispatch): Promise<void> => {
    const { data } = await getTopAirports(payload);
    dispatch({
      type: OperationsActionTypes.UPDATE_TOP_AIRPORTS,
      payload: {
        airports: data,
      },
    });
  };

interface TopAircraftPayload {
  payload: {
    from: string;
    to: string;
    aircraft_id: string[];
    date?: 'year' | 'month' | string;
  };
}

export const fetchTopAircraft =
  ({ payload }: TopAircraftPayload) =>
  async (dispatch: Dispatch): Promise<void> => {
    const { data } = await getTopAircraft(payload);
    if (payload.date === 'year') {
      dispatch({
        type: OperationsActionTypes.UPDATE_TOP_AIRCRAFT_YEAR,
        payload: {
          prevYear: {
            aircraftHours: data.hours,
            aircraftFlights: data.flights,
          },
        },
      });
    } else if (payload.date === 'month') {
      dispatch({
        type: OperationsActionTypes.UPDATE_TOP_AIRCRAFT_MONTH,
        payload: {
          prevMonth: {
            aircraftHours: data.hours,
            aircraftFlights: data.flights,
          },
        },
      });
    } else {
      dispatch({
        type: OperationsActionTypes.UPDATE_TOP_AIRCRAFT_CURRENT,
        payload: {
          current: {
            aircraftHours: data.hours,
            aircraftFlights: data.flights,
          },
        },
      });
    }
  };

interface MonthlySummaryPayload {
  payload: {
    organisation_id: string;
    aircraft: string[];
    dateFormat: string;
  };
}

export const fetchMonthlySummary =
  ({ payload }: MonthlySummaryPayload) =>
  async (dispatch: Dispatch): Promise<void> => {
    const { data } = await getMonthlySummary(payload);
    dispatch({
      type: OperationsActionTypes.UPDATE_MONTHLY_SUMMARY,
      payload: {
        monthly: data,
      },
    });
  };

interface OilConsumptionPayload {
  payload: {
    organisation_id: string;
    aircraft: string[];
    range: number;
    dateFormat: string;
  };
}

export const fetchOilConsumption =
  ({ payload }: OilConsumptionPayload) =>
  async (dispatch: Dispatch): Promise<void> => {
    const data = await getOilConsumption(payload);
    dispatch({
      type: OperationsActionTypes.UPDATE_OIL_CONSUMPTION,
      payload: {
        oilConsumption: data,
      },
    });
  };

interface RoutesPayload {
  payload: {
    from: string;
    to: string;
    aircraft: string[];
  };
}

export const fetchRoutes =
  ({ payload }: RoutesPayload) =>
  async (dispatch: Dispatch): Promise<void> => {
    const promiseArray = [];
    const clonedAircraftPayload = [...payload.aircraft];

    do {
      const currentBatchOfAircraft = clonedAircraftPayload.splice(0, 20);
      promiseArray.push(getRoutes({ aircraft: currentBatchOfAircraft, from: payload.from, to: payload.to }));
    } while (clonedAircraftPayload.length > 20);

    const response = await Promise.all(promiseArray);
    const data = response.reduce((acc, curr) => {
      return acc.concat(curr.data);
    }, [] as FlightRoute[]);
    dispatch({
      type: OperationsActionTypes.UPDATE_ROUTES,
      payload: {
        routes: data,
      },
    });
  };

export const clearMonthlySummary =
  () =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: OperationsActionTypes.CLEAR_MONTHLY,
    });
  };

export const clearRoutes =
  () =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: OperationsActionTypes.CLEAR_ROUTES,
    });
  };
